// Split out from userData.js so it's unit-testable — userData.js can't be
// imported under jest (jsdom chokes on its import chain).

// os_codename is nested under software. Direct VMs get it from the backend;
// pool stubs get it from vmpool.os_codename in the load functions.
export const vm_os_codename = vm => (vm && vm.software && vm.software.os_codename) || '';

// Cameras are Windows 10/11 only.
export const os_codename_is_camera_capable = os_codename => {
  const oc = (os_codename || '').toLowerCase();
  return oc.startsWith('w10') || oc.startsWith('w11');
};

// perm.vm is the pool stub (also carries the pool OS now); the real vm is on
// pool_vm — check both.
export const perm_is_camera_capable = perm =>
  !!perm && os_codename_is_camera_capable(
    vm_os_codename(perm.vm) || vm_os_codename(perm.pool_vm)
  );
